import { BlymLoading } from './loading';

type LoadingScreenProps = {
  text?: string;
};

export function LoadingScreen({ text }: LoadingScreenProps) {
  return (
    <div className="flex h-screen max-h-full w-screen max-w-full items-center justify-center">
      <div className="flex flex-col items-center justify-center">
        <BlymLoading />
        {text != null ? <p className="font-display-3 mt-8 text-center">{text}</p> : null}
      </div>
    </div>
  );
}
